import React from "react";
import { BookingTypes } from "../../../../../Bookings/BookingsSearch/BookingsSearch";
import { WayFinderFormWorkspacesItem } from "./WayFinderFormWorkspacesItem";
import { WorkplaceFields } from "../../../../../../api/graphql/workplaces";

import {
  MAX_DESKS_WAYFINDER,
  MAX_ROOMS_WAYFINDER,
} from "../../../../../../lib/utils/constants";

import "./WayFinderFormWorkspaces.scss";

interface Props {
  type: BookingTypes | "workspaces";
  data: WorkplaceFields[];
  hideCounter?: boolean;
  showDataLength?: boolean;
  handleWorkspace: (
    item: WorkplaceFields,
    type: "desks" | "rooms",
    methodType: "add" | "delete"
  ) => void;
  onClick?: (item: WorkplaceFields) => void;
}

export const WayFinderFormWorkspaces = ({
  type,
  data,
  hideCounter,
  showDataLength,
  handleWorkspace,
  onClick,
}: Props) => {
  return (
    <div className="WayFinderFormWorkspaces">
      <label className="label__main mt-3">
        {data.length <= 0 ? "No added" : "Added"} {type}s
      </label>

      {showDataLength && (
        <span className="WayFinderFormWorkspaces__counter">
          ({data.length})
        </span>
      )}

      {!hideCounter && (
        <span className="WayFinderFormWorkspaces__counter">
          ({data.length} of max{" "}
          {type === "room" ? MAX_ROOMS_WAYFINDER : MAX_DESKS_WAYFINDER})
        </span>
      )}

      <div className="WayFinderFormWorkspaces__list d-flex flex-wrap">
        {data.map((item) => (
          <WayFinderFormWorkspacesItem
            key={item.id}
            workspace={item}
            handleWorkspace={handleWorkspace}
            onClick={onClick}
          />
        ))}
      </div>
    </div>
  );
};
